import { render } from "./CameraScreen.vue?vue&type=template&id=46cf194d&scoped=true"
import script from "./CameraScreen.vue?vue&type=script&lang=js"
export * from "./CameraScreen.vue?vue&type=script&lang=js"

import "./CameraScreen.vue?vue&type=style&index=0&id=46cf194d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cf194d"]])

export default __exports__